import { combineReducers } from "redux";
import constants from "./constants";
import createApiReducer from "reducers/createReducers";

const reducers = combineReducers({
  remainingBudgetList: createApiReducer(constants.GET_REMAIN_BUDGET_LIST, {}),
  avgUsage: createApiReducer(constants.GET_AVG_USAGE, 0),
  paymentHistory: createApiReducer(constants.PAYMENT_HISTORY, []),
});

export default reducers;
